/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TimezoneMetadata } from './TimezoneMetadata';
import {
    TimezoneMetadataFromJSON,
    TimezoneMetadataFromJSONTyped,
    TimezoneMetadataToJSON,
    TimezoneMetadataToJSONTyped,
} from './TimezoneMetadata';
import type { GoldenRecord } from './GoldenRecord';
import {
    GoldenRecordFromJSON,
    GoldenRecordFromJSONTyped,
    GoldenRecordToJSON,
    GoldenRecordToJSONTyped,
} from './GoldenRecord';

/**
 * 
 * @export
 * @interface GoldenRecordsResponse
 */
export interface GoldenRecordsResponse {
    /**
     * 
     * @type {boolean}
     * @memberof GoldenRecordsResponse
     */
    success?: boolean;
    /**
     * 
     * @type {Array<GoldenRecord>}
     * @memberof GoldenRecordsResponse
     */
    data?: Array<GoldenRecord>;
    /**
     * 
     * @type {number}
     * @memberof GoldenRecordsResponse
     */
    total?: number;
    /**
     * 
     * @type {number}
     * @memberof GoldenRecordsResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof GoldenRecordsResponse
     */
    pageSize?: number;
    /**
     * 
     * @type {string}
     * @memberof GoldenRecordsResponse
     */
    errorMessage?: string;
    /**
     * 
     * @type {string}
     * @memberof GoldenRecordsResponse
     */
    userTimezone?: string;
    /**
     * Error message if the request failed
     * @type {string}
     * @memberof GoldenRecordsResponse
     */
    error?: string;
    /**
     * 
     * @type {TimezoneMetadata}
     * @memberof GoldenRecordsResponse
     */
    timezoneMetadata?: TimezoneMetadata;
}

/**
 * Check if a given object implements the GoldenRecordsResponse interface.
 */
export function instanceOfGoldenRecordsResponse(value: object): value is GoldenRecordsResponse {
    return true;
}

export function GoldenRecordsResponseFromJSON(json: any): GoldenRecordsResponse {
    return GoldenRecordsResponseFromJSONTyped(json, false);
}

export function GoldenRecordsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoldenRecordsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(GoldenRecordFromJSON)),
        'total': json['total'] == null ? undefined : json['total'],
        'page': json['page'] == null ? undefined : json['page'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
        'userTimezone': json['userTimezone'] == null ? undefined : json['userTimezone'],
        'error': json['error'] == null ? undefined : json['error'],
        'timezoneMetadata': json['timezone_metadata'] == null ? undefined : TimezoneMetadataFromJSON(json['timezone_metadata']),
    };
}

export function GoldenRecordsResponseToJSON(json: any): GoldenRecordsResponse {
    return GoldenRecordsResponseToJSONTyped(json, false);
}

export function GoldenRecordsResponseToJSONTyped(value?: GoldenRecordsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(GoldenRecordToJSON)),
        'total': value['total'],
        'page': value['page'],
        'pageSize': value['pageSize'],
        'errorMessage': value['errorMessage'],
        'userTimezone': value['userTimezone'],
        'error': value['error'],
        'timezone_metadata': TimezoneMetadataToJSON(value['timezoneMetadata']),
    };
}

